<div class="container" [formGroup]="filters">
    <div class="half-container">
        <p class="title">{{'TITLE_REPORT_FIELDS' | translate }}</p>
        <p class="subtitle">{{"SUBTITLE_DEVICE_MANAGEMENT" | translate}}</p>

    </div>

    <div class="half-container">
        <div class="cardsContainer">
            <div class="card">
                <div class="select">
                    <mat-form-field color="white" class="matformSelect">
                        <mat-label class="textSelect">
                            {{ "DEVICE_INCIDENT_TYPE" | translate }}
                        </mat-label>
                        <mat-select #selIncidentType formControlName="incidentType" multiple>


                            <mat-select-trigger>
                                <span *ngIf="((filters.get('incidentType').value?.length || 0) == 1)">
                                    {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                                </span>
                                <span
                                    *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                                    {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                                </span>

                                <span
                                    *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                                    {{ filters.get('incidentType').value[1]?.name || "SELECT_ALL" | translate }}
                                </span>

                                <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1)">
                                    (+{{(filters.get('incidentType').value?.length || 0) - 1}}
                                    {{filters.get('incidentType')?.length
                                    === 2 ? '...' : '...'}})
                                </span>
                            </mat-select-trigger>


                            <mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" |
                                translate
                                }}</mat-option>
                            <mat-option *ngFor="let option of arrayDevicesIncidentsTypes"
                                [value]="option">{{option.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>
            </div>
            <div class="card">
                <!-- <p class="textSelect">
                    {{ "ENTER_DATE_RANGE" | translate }}
                </p> -->
                <div class="selectDate">
                    <mat-form-field class="matformDate">
                        <mat-label class="textSelect">
                            <!-- {{ "ENTER_DATE_RANGE" | translate }} -->
                            <p class="textSelect">{{ "YEAR_MONTH_DAY" | translate }}</p>
                        </mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate formControlName="start" #dateRangeStart>
                            <!-- (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" -->
                            <input matEndDate formControlName="end" #dateRangeEnd>
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>


                </div>

            </div>
            <div class="card">
                <div class="select">
                    <mat-form-field color="white" class="matformSelect matformSelect-status">
                        <mat-label class="textSelect">
                            {{ "incidentStatus" | translate }}
                        </mat-label>
                        <mat-select #selStatus formControlName="status" multiple>


                             <mat-select-trigger>
                    <span *ngIf="((filters.get('status').value?.length || 0) == 1)">
                      {{ filters.get('status').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>
                    <span
                      *ngIf="((filters.get('status').value?.length || 0) > 1 && filters.get('status').value[0]?.name !== undefined)">
                      {{ filters.get('status').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span
                      *ngIf="((filters.get('status').value?.length || 0) > 1 && filters.get('status').value[0]?.name == undefined)">
                      {{ filters.get('status').value[1]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span *ngIf="((filters.get('status').value?.length || 0) > 1)">
                      (+{{(filters.get('status').value?.length || 0) - 1}} {{filters.get('status')?.length === 2 ? '...'
                      : '...'}})
                    </span>
                  </mat-select-trigger>

                  <mat-option (click)="toggleAllSelection(selStatus)" [value]="0">{{ "SELECT_ALL" | translate
                    }}</mat-option>
                            <mat-option *ngFor="let option of arrayReportStatus"
                                [value]="option">{{option.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card1 button-card">
            <button mat-raised-button (click)="getCallFieldsDevicesReview()">
                <span class="confirm-ico-btn"></span>
                {{ "SEARCH" | translate }}
            </button>
        </div>
    </div>
</div>

<neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration" [ShowChecks]="false"
    [GridTitle]="'SUBTITLE_DEVICE_MANAGEMENT' | translate" [Data]="arrayGirdFieldsReviewGrid"
    (cellClickEvent)="cellClick($event)"></neoris-grid>